
import {
  Vue, Component, Watch,
  Mixins,
} from 'vue-property-decorator';
import moment from 'moment';
import AttachmentsList from '@/components/AttachmentsList.vue';
import {
  BoxStatusType, User,
  PracticeAssignedType,
  AssignmentEntry,
} from '@/types';
import AssignmentEntryItem from '@/components/AssignmentEntryItem.vue';
import OperationAssignmentsDialog from '@/components/OperationAssignmentsDialog.vue';
import TaskStatusAlert from '@/components/TaskStatusAlert.vue';
import TaskActions from '@/components/TaskActions.vue';
import TaskActivityBox from '@/components/TaskActivityBox.vue';
import SwitchWithConfirm from '@/components/SwitchWithConfirm.vue';
import CurrentSupply from '@/components/CurrentSupply.vue';
import SupplyAlertDialog from '@/components/SupplyAlertDialog.vue';
import EditLeadSupplyDialog from '@/components/EditLeadSupplyDialog.vue';
import UserGroups from '@/components/UserGroups.vue';
import Editor from '@/components/Editor.vue';
import DatePickerDialog from '@/components/DatePickerDialog.vue';
import WeekPickerDialog from '@/components/WeekPickerDialog.vue';
import ConnectionLastStep from '@/components/connections/ConnectionLastStep.vue';
import CheckZonaVincolo from '@/components/CheckZonaVincolo.vue';
import EditCheckZonaVincoloDialog from '@/components/EditCheckZonaVincoloDialog.vue';
import CheckAccountGSE from '@/components/CheckAccountGSE.vue';
import EditCheckAccountGSEDialog from '@/components/EditCheckAccountGSEDialog.vue';
import TaskAttachmentsDialog from '@/components/TaskAttachmentsDialog.vue';
import {
  getLeadCustomValue,
  getLeadCustomValueBoolean, getLeadCustomValueDate, getLeadCustomValueText,
} from '@/helpers';
import TaskMixin from '@/mixins/TaskMixin.vue';
import UtilsMixin from '@/mixins/UtilsMixin.vue';

moment.locale('it');

@Component({
  components: {
    TaskStatusAlert,
    TaskActions,
    AttachmentsList,
    TaskActivityBox,
    SwitchWithConfirm,
    CheckZonaVincolo,
    EditCheckZonaVincoloDialog,
    CurrentSupply,
    SupplyAlertDialog,
    EditLeadSupplyDialog,
    CheckAccountGSE,
    EditCheckAccountGSEDialog,
    TaskAttachmentsDialog,
    UserGroups,
    Editor,
    DatePickerDialog,
    WeekPickerDialog,
    ConnectionLastStep,
    AssignmentEntryItem,
    OperationAssignmentsDialog,
  },
})
export default class TaskV extends Mixins(TaskMixin, UtilsMixin) {
  supplyAlertDialog = false
  editSupplyDialog = false
  editCheckZonaVincolo = false
  editCheckAccountGSE = false
  editAttachmentsDialog = false
  editProjectAssignmentDialog = false
  editPracticeAssignmentDialog = false

  // Project assignment
  projectAssigneeId: number | null = null
  projectAssigned: string | null = null
  projectAssignedDate: Date | null = null
  projectAssignees: string | null = null
  practiceAssignees: string | null = null

  @Watch('editSupplyDialog')
  onEditSupplyDialogChange(val: boolean) {
    // Quando il dialog viene chiuso, aggiorna CurrentSupply
    if (!val && this.$refs.currentSupply) {
      (this.$refs.currentSupply as any).refreshSupply();
    }
  }

  // Staged save dal dialog degli incarichi (modalità defer-save). Aggiorna i
  // campi locali reattivi letti da practiceEntry/projectEntry e accumula il
  // body nel pendingUpdate del Task: verrà inviato al click di UpdateButton.
  onAssignmentSaved(payload: { body: Record<string, unknown> }) {
    const { body } = payload;

    if ('projectAssigned' in body) {
      this.projectAssigneeId = (body.projectAssignee as number) ?? null;
      this.projectAssigned = (body.projectAssigned as string) ?? null;
      this.projectAssignedDate = (body.projectAssignedDate as Date) ?? null;
    }

    if ('practiceAssigned' in body) {
      this.practiceAssignee = (body.practiceAssignee as number) ?? null;
      this.practiceAssigned = (body.practiceAssigned as PracticeAssignedType) ?? 'todo';
      this.practiceAssignedDate = (body.practiceAssignedDate as Date) ?? null;
    }

    this.$store.dispatch('updateTaskFields', body);
  }

  titoloAutorizzativo: BoxStatusType = 'todo'
  progettoElettrico: BoxStatusType = 'todo'
  progettoTermico: BoxStatusType = 'todo'
  computoMetrico: BoxStatusType = 'todo'

  checkZonaVincolo: BoxStatusType = 'todo'
  checkZonaVincoloLastUpdate: Date | null = null
  checkZonaVincoloUpdater: string | null | undefined = null
  checkZonaVincoloNotes: string | null | undefined = null

  autodichiarazioneCliente: BoxStatusType = 'todo'
  autodichiarazioneClienteNotes: string | null | undefined = null

  practiceAssignedValues = [
    {
      text: 'Da assegnare',
      value: 'todo',
    },
    {
      text: 'Assegnate',
      value: 'done',
    },
    {
      text: 'Non applicabile',
      value: 'na',
    },
  ]

  iterValues = [
    {
      text: 'Ordinario',
      value: 'o',
    },
    {
      text: 'Semplificato',
      value: 's',
    },
    {
      text: 'Superbonus 110% - Ordinario',
      value: 'bo',
    },
    {
      text: 'Superbonus 110% - Semplificato',
      value: 'bs',
    },
    {
      text: 'Superbonus 110%',
      value: 'b',
    },
    {
      text: 'Pre Check Connessione',
      value: 'ps',
    },
    {
      text: 'Non applicabile',
      value: 'n',
    },
  ]

  iter: string | null = null
  practiceNotes: string | null | undefined = null
  titoloAutorizzativoNotes: string | null | undefined = null
  progettoElettricoNotes: string | null | undefined = null
  progettoTermicoNotes: string | null | undefined = null
  computoMetricoNotes: string | null | undefined = null

  practiceAssignee: number | null = null

  powerDetails1: string | null | undefined = null
  powerDetails2: string | null | undefined = null
  powerDetails3: string | null | undefined = null
  powerDetails4: string | null | undefined = null
  powerDetails5: string | null | undefined = null

  practiceAssigned: PracticeAssignedType = 'todo'
  practiceAssignedDate: Date | null = null

  titoloAutorizzativoDate: Date | null = null;

  ePlanDate: Date | null = null;
  ePlanDoneDate: Date | null = null;
  tPlanDate: Date | null = null;
  ePlanDateViewMode: string | null | undefined = null
  tPlanDateViewMode: string | null | undefined = null

  datePickerDialog = false
  weekPickerDialog = false
  datePickerDate: string | null = null
  datePickerName: string | null = null

  eCostsVerified = false
  tCostsVerified = false
  tConversionDone = false
  tCeilingsVerified = false
  tCertifierVerified = false

  verificationsNotes: string | null | undefined = null

  // Aggiorna solo i campi relativi agli assignment (practice e project)
  // senza sovrascrivere le altre modifiche non salvate dell'utente.
  refreshAssignmentFields() {
    const leadAny = this.selectedLead as Record<string, unknown> | null;

    // Practice
    const fromTopLevel = leadAny && ('practiceAssigneeId' in leadAny || 'practiceAssigned' in leadAny);
    const practiceAssigneeCV = getLeadCustomValue(this.selectedLead, 'practiceAssignee');
    this.practiceAssignee = fromTopLevel && leadAny?.practiceAssigneeId != null
      ? Number(leadAny.practiceAssigneeId)
      : (practiceAssigneeCV?.userValueId ?? null);
    this.practiceAssigned = (fromTopLevel && leadAny?.practiceAssigned != null
      ? leadAny.practiceAssigned
      : (getLeadCustomValueText(this.selectedLead, 'practiceAssigned') ?? 'todo')) as PracticeAssignedType;
    this.practiceAssignedDate = fromTopLevel && leadAny?.practiceAssignedDate != null
      ? (leadAny.practiceAssignedDate as Date)
      : getLeadCustomValueDate(this.selectedLead, 'practiceAssignedDate');
    this.practiceAssignees = getLeadCustomValueText(this.selectedLead, 'practiceAssignees') ?? '[]';

    // Project
    const projectFromTopLevel = leadAny && ('projectAssigneeId' in leadAny || 'projectAssigned' in leadAny);
    const projectAssigneeCV = getLeadCustomValue(this.selectedLead, 'projectAssignee');
    this.projectAssigneeId = projectFromTopLevel && leadAny?.projectAssigneeId != null
      ? Number(leadAny.projectAssigneeId)
      : (projectAssigneeCV?.userValueId ?? null);
    this.projectAssigned = (projectFromTopLevel && leadAny?.projectAssigned != null
      ? leadAny.projectAssigned
      : (getLeadCustomValueText(this.selectedLead, 'projectAssigned') ?? 'todo')) as string;
    this.projectAssignedDate = projectFromTopLevel && leadAny?.projectAssignedDate != null
      ? (leadAny.projectAssignedDate as Date)
      : getLeadCustomValueDate(this.selectedLead, 'projectAssignedDate');
    this.projectAssignees = getLeadCustomValueText(this.selectedLead, 'projectAssignees') ?? '[]';
  }

  // Aggiorna i campi con gli eventuali nuovi valori della Lead selezionata
  refreshTask() {
    console.log(`${this.constructor.name}: refreshTask()`); // eslint-disable-line no-console

    this.iter = getLeadCustomValueText(this.selectedLead, 'iter');

    // Se l'iter non è impostato sul valore legacy "b",
    // lo rimuove nell'elenco dei possibili valori.
    if (this.iter !== 'b') {
      this.iterValues = this.iterValues.filter((v) => v.value !== 'b');
    }

    this.titoloAutorizzativoDate = this.selectedLead?.titoloAutorizzativoDate ?? null;

    // Le informazioni sul Check Zona di Vincolo sono memorizzate nella Lead padre
    this.checkZonaVincolo = (getLeadCustomValueText(this.father, 'checkZonaVincolo') ?? 'todo') as BoxStatusType;
    this.checkZonaVincoloLastUpdate = getLeadCustomValueDate(this.father, 'checkZonaVincoloLastUpdate');
    this.checkZonaVincoloUpdater = getLeadCustomValueText(this.father, 'checkZonaVincoloUpdater');
    this.checkZonaVincoloNotes = getLeadCustomValueText(this.father, 'checkZonaVincoloNotes');

    // Le informazioni sull'autodichiarazione cliente sono memorizzate nella Lead padre
    this.autodichiarazioneCliente = (getLeadCustomValueText(this.father, 'autodichiarazioneCliente') ?? 'todo') as BoxStatusType;
    this.autodichiarazioneClienteNotes = getLeadCustomValueText(this.father, 'autodichiarazioneClienteNotes');

    this.ePlanDate = getLeadCustomValueDate(this.selectedLead, 'ePlanDate');
    this.ePlanDoneDate = getLeadCustomValueDate(this.selectedLead, 'ePlanDoneDate');
    this.tPlanDate = getLeadCustomValueDate(this.selectedLead, 'tPlanDate');
    this.ePlanDateViewMode = getLeadCustomValueText(this.selectedLead, 'ePlanDateViewMode') ?? 'week';
    this.tPlanDateViewMode = getLeadCustomValueText(this.selectedLead, 'tPlanDateViewMode') ?? 'week';

    this.eCostsVerified = getLeadCustomValueBoolean(this.selectedLead, 'eCostsVerified') ?? false;

    this.tCostsVerified = getLeadCustomValueBoolean(this.selectedLead, 'tCostsVerified') ?? false;
    this.tConversionDone = getLeadCustomValueBoolean(this.selectedLead, 'tConversionDone') ?? false;
    this.tCeilingsVerified = getLeadCustomValueBoolean(this.selectedLead, 'tCeilingsVerified') ?? false;
    this.tCertifierVerified = getLeadCustomValueBoolean(this.selectedLead, 'tCertifierVerified') ?? false;

    this.verificationsNotes = this.leadType === 'elettrica-figlia'
      ? getLeadCustomValueText(this.selectedLead, 'eVerificationsNotes')
      : getLeadCustomValueText(this.selectedLead, 'tVerificationsNotes');

    this.refreshAssignmentFields();
    this.practiceNotes = getLeadCustomValueText(this.father, 'practiceNotes');

    // Carica la configurazione degli assignment types se necessario
    if (this.$store.getters.getAssignmentTypes.length === 0) {
      this.$store.dispatch('fetchAssignmentTypes');
    }

    this.titoloAutorizzativo = (this.selectedLead?.titoloAutorizzativo ?? 'todo') as BoxStatusType;
    this.titoloAutorizzativoNotes = getLeadCustomValueText(this.selectedLead, 'titoloAutorizzativoNotes');

    this.progettoElettrico = (getLeadCustomValueText(this.selectedLead, 'progettoElettrico') ?? 'todo') as BoxStatusType;
    this.progettoElettricoNotes = getLeadCustomValueText(this.selectedLead, 'progettoElettricoNotes');

    this.powerDetails1 = getLeadCustomValueText(this.selectedLead, 'powerDetails1');
    this.powerDetails2 = getLeadCustomValueText(this.selectedLead, 'powerDetails2');
    this.powerDetails3 = getLeadCustomValueText(this.selectedLead, 'powerDetails3');
    this.powerDetails4 = getLeadCustomValueText(this.selectedLead, 'powerDetails4');
    this.powerDetails5 = getLeadCustomValueText(this.selectedLead, 'powerDetails5');

    this.progettoTermico = (getLeadCustomValueText(this.selectedLead, 'progettoTermico') ?? 'todo') as BoxStatusType;
    this.progettoTermicoNotes = getLeadCustomValueText(this.selectedLead, 'progettoTermicoNotes');

    this.computoMetrico = (getLeadCustomValueText(this.selectedLead, 'computoMetrico') ?? 'todo') as BoxStatusType;
    this.computoMetricoNotes = getLeadCustomValueText(this.selectedLead, 'computoMetricoNotes');

    // Richiama il metodo implementato nel mixin
    return this.mixinRefreshTask();
  }

  // I dati extra sono validi?
  get isExtraDataValid(): boolean {
    // Se è impossibile completare il task, i dati extra sono ignorati
    // FIXME: Rimuovere quando questo Task userà il mixin TaskMixin
    if (this.selectedStatus === 'error') return true;

    if (this.leadType === 'elettrica-figlia') {
      // Le 'elettrica-figlia' richiedono 'progettoElettrico'

      // Le attività sono da fare o in attesa
      if (this.progettoElettrico === 'todo' || this.progettoElettrico === 'waiting') return false;

      // Le attività sono completate ma manca l'allegato
      if (this.progettoElettrico === 'done' && !this.hasAttachments('progettoElettrico')) return false;
    } else
    if (this.leadType === 'termica-figlia') {
      // Le 'termica-figlia' richiedono 'progettoTermico'

      // Le attività sono da fare o in attesa
      if (this.progettoTermico === 'todo' || this.progettoTermico === 'waiting') return false;

      // Le attività sono completate ma manca l'allegato
      if (this.progettoTermico === 'done' && !this.hasAttachments('progettoTermico')) return false;
    }

    // Le attività sono da fare o in attesa
    if (this.titoloAutorizzativo === 'todo' || this.titoloAutorizzativo === 'waiting') return false;
    if (this.computoMetrico === 'todo' || this.computoMetrico === 'waiting') return false;

    // Le attività sono completate ma manca l'allegato
    if (this.titoloAutorizzativo === 'done' && !this.fatherHasAttachments('titoloAutorizzativo')) return false;
    if (this.computoMetrico === 'done' && !this.hasAttachments('computoMetrico')) return false;

    // Se il titolo autorizzativo è !== 'na' ma manca la data, è un errore
    if (this.titoloAutorizzativo !== 'na' && !this.titoloAutorizzativoDate) return false;

    // In tutti gli altri casi...
    return true;
  }

  get users(): User[] { return this.$store.getters.users; }

  get practiceAssigneeUsers(): User[] {
    return this.$store.getters.users
      .filter((u: User) => {
        const userGroups = u.groups.map((g) => g.id);
        return userGroups.includes(19);
      });
  }

  get practiceAssigneeName(): string {
    const user = this.users.find((u) => u.id === this.practiceAssignee);
    return user?.name ?? '';
  }

  get projectAssigneeName(): string | null {
    if (!this.projectAssigneeId) return null;
    const user = this.users.find((u) => u.id === this.projectAssigneeId);
    return user?.name ?? null;
  }

  get projectEntry(): AssignmentEntry {
    const config = this.$store.getters.getAssignmentType('project');
    return {
      type: 'project',
      label: config?.label || 'Assegnatario del progetto',
      icon: config?.icon || 'mdi-pencil-ruler',
      dateTooltip: 'Data assegnazione progetto',
      permissionShow: 'projectAssignment.show',
      permissionEdit: 'projectAssignment.edit',
      multipleAssignees: false,
      assignees: [],
      assigneeId: this.projectAssigneeId,
      assigneeName: this.projectAssigneeName,
      assigned: this.projectAssigned,
      assignedDate: this.projectAssignedDate,
    };
  }

  get practiceEntry(): AssignmentEntry {
    const config = this.$store.getters.getAssignmentType('practice');
    return {
      type: 'practice',
      label: config?.label || 'Assegnatario delle pratiche di connessione',
      icon: config?.icon || 'mdi-transmission-tower',
      dateTooltip: 'Data assegnazione pratiche',
      permissionShow: 'practiceAssignment.show',
      permissionEdit: 'practiceAssignment.edit',
      multipleAssignees: false,
      assignees: [],
      assigneeId: this.practiceAssignee,
      assigneeName: this.practiceAssigneeName || null,
      assigned: this.practiceAssigned,
      assignedDate: this.practiceAssignedDate,
    };
  }

  get practiceAssignmentOperation(): Record<string, unknown> | null {
    const lead = this.selectedLead;
    if (!lead) return null;
    return {
      children: {
        [lead.id]: {
          type: this.leadType,
          practiceAssigneeId: this.practiceAssignee,
          practiceAssigned: this.practiceAssigned,
          practiceAssignedDate: this.practiceAssignedDate,
          practiceAssignees: this.practiceAssignees,
          firstTaskId: this.selectedTask?.id || null,
        },
      },
    };
  }

  get projectAssignmentOperation(): Record<string, unknown> | null {
    const lead = this.selectedLead;
    if (!lead) return null;
    return {
      children: {
        [lead.id]: {
          type: this.leadType,
          projectAssigneeId: this.projectAssigneeId,
          projectAssigned: this.projectAssigned,
          projectAssignedDate: this.projectAssignedDate,
          projectAssignees: this.projectAssignees,
          firstTaskId: this.selectedTask?.id || null,
        },
      },
    };
  }

  onEditProjectAssignment() {
    if (!this.hasPermission('projectAssignment.edit')) return;
    if (this.fieldsDisabled) return;
    this.editProjectAssignmentDialog = true;
  }

  onEditPracticeAssignment() {
    if (!this.hasPermission('practiceAssignment.edit')) return;
    if (this.fieldsDisabled) return;
    this.editPracticeAssignmentDialog = true;
  }

  updateBoxStatus(name: string, status: BoxStatusType) {
    console.log(`${this.constructor.name}: updateBoxStatus(${name}, ${status})`); // eslint-disable-line no-console

    // Se lo stato non esiste si ferma subito
    if (name in this === false) { return; }

    this[name] = status;

    const update = {} as { [key: string]: unknown };

    update[name] = status;

    // Aggiorno i campi collegati
    switch (name) {
      case 'progettoElettrico':
        if (status === 'done') {
          this.ePlanDoneDate = moment(moment(), 'YYYY-MM-DD').toDate();
          update.ePlanDoneDate = this.ePlanDoneDate;
        } else {
          this.ePlanDoneDate = null;
          update.ePlanDoneDate = null;
        }
        break;
      default:
        break;
    }

    this.$store.dispatch('updateTaskFields', update);

    if (this.hasPermission('supply.edit')
      && (name === 'progettoTermico' || name === 'progettoElettrico')
      && status === 'done') this.supplyAlertDialog = true;
  }

  // Mostra le azioni
  get showActions(): boolean { return !this.task && !this.readonly && !this.embedded; }

  planDateString(date: Date | null | undefined, viewMode: string): string | null {
    switch (viewMode) {
      case 'ePlanDateViewMode':
        return this.ePlanDateViewMode === 'week' ? this.mWeek(date) : this.mDate(date);

      case 'tPlanDateViewMode':
        return this.tPlanDateViewMode === 'week' ? this.mWeek(date) : this.mDate(date);

      default:
        return null;
    }
  }

  initialPickerMode(): string | null | undefined {
    switch (this.datePickerName) {
      case 'ePlanDate':
        return this.ePlanDateViewMode;

      case 'tPlanDate':
        return this.tPlanDateViewMode;

      default:
        return 'week';
    }
  }

  onFieldUpdated(field: string) {
    console.log(`${this.constructor.name}: onFieldUpdated(${field})`); // eslint-disable-line no-console

    const update = {} as { [key: string]: unknown };

    // Prepara l'aggiornamento e aggiorna eventuali campi collegati.
    // Nota: i case 'practiceAssigned' e 'practiceAssignee' sono stati rimossi
    // perché irraggiungibili — l'assegnazione pratiche passa da
    // AssignmentEntryItem + OperationAssignmentsDialog (deferSave), che emette
    // il body a onAssignmentSaved().
    switch (field) {
      case 'verificationsNotes':
        if (this.leadType === 'elettrica-figlia') update.eVerificationsNotes = this.verificationsNotes ?? '';
        if (this.leadType === 'termica-figlia') update.tVerificationsNotes = this.verificationsNotes ?? '';
        break;

      // In tutti gli altri casi...
      default:
        // ...  aggiorna il campo specificato
        update[field] = this[field] ?? '';
        break;
    }

    this.$store.dispatch('updateTaskFields', update);
  }

  onClickDate(name: string) {
    console.log(`${this.constructor.name}: onClickDate(${name})`); // eslint-disable-line no-console

    if (this.leadStatus !== 'open'
      || this.taskStatus !== null
      || this.readonly) return;

    // Imposta per quale campo verrà utilizzato il DatePicker
    this.datePickerName = name;

    // Imposta l'eventuale data precedentemente selezionata
    this.datePickerDate = this[name]
      ? moment(this[name]).toISOString(true).substring(0, 10)
      : null;

    // Apre il dialog per la selezione della data o della settimana
    switch (name) {
      case 'ePlanDate':
      case 'tPlanDate':
        this.weekPickerDialog = true;
        break;

      default:
        this.datePickerDialog = true;
        break;
    }
  }

  onClearDate(name: string) {
    console.log(`${this.constructor.name}: onClearDate(${name})`); // eslint-disable-line no-console

    if (this.leadStatus !== 'open') return;

    const update = {} as { [key: string]: unknown };

    // Cancello la data nel modulo e nel prossimo aggiornamento
    if (name in this) {
      this[name] = null;
      update[name] = null;
    }

    // Modifico eventuali campi collegati
    switch (name) {
      default:
        break;
    }

    // Valido il modulo con le nuove informazioni inserite
    this.onValidate('completed');

    this.$store.dispatch('updateTaskFields', update);
  }

  onSelectDate(date: string | null, mode: string | null) {
    console.log(`${this.constructor.name}: onSelectDate() date=${date}, mode=${mode}`); // eslint-disable-line no-console

    if (!this.datePickerName) return;

    // Chiudo il dialog per la selezione della data o della settimana
    this.datePickerDialog = false;
    this.weekPickerDialog = false;

    const update = {} as { [key: string]: unknown };

    // Trasforma in un valore di tipo Date prima di restituirlo
    const selectedDate = date
      ? moment(date, 'YYYY-MM-DD').toDate()
      : null;

    // Inserisco la data nel modulo e nell'aggiornamento
    if (this.datePickerName in this) {
      this[this.datePickerName] = selectedDate;
      update[this.datePickerName] = this[this.datePickerName];
    }

    // Modifico eventuali campi collegati
    switch (this.datePickerName) {
      case 'ePlanDate':
        this.ePlanDateViewMode = mode;
        update.ePlanDateViewMode = this.ePlanDateViewMode;
        break;

      case 'tPlanDate':
        this.tPlanDateViewMode = mode;
        update.tPlanDateViewMode = this.tPlanDateViewMode;
        break;

      default:
        break;
    }

    // Valido il modulo con le nuove informazioni inserite
    this.onValidate('completed');

    this.$store.dispatch('updateTaskFields', update);
  }

  onCheckZonaVincoloUpdate(update: { [key: string]: unknown }) {
    console.log(`${this.constructor.name}: onCheckZonaVincoloUpdate() update =`, update); // eslint-disable-line no-console

    // checkZonaVincolo, checkZonaVincoloLastUpdate, checkZonaVincoloUpdater
    if ('checkZonaVincolo' in update && update.checkZonaVincolo !== this.checkZonaVincolo) {
      this.checkZonaVincolo = update.checkZonaVincolo as BoxStatusType;
      this.checkZonaVincoloLastUpdate = new Date();
      this.checkZonaVincoloUpdater = this.$store.getters.currentUser?.name ?? null;

      this.$store.dispatch('updateTaskFields', {
        checkZonaVincolo: this.checkZonaVincolo,
        checkZonaVincoloLastUpdate: this.checkZonaVincoloLastUpdate,
        checkZonaVincoloUpdater: this.checkZonaVincoloUpdater,
      });
    }
    // checkZonaVincoloNotes
    if ('checkZonaVincoloNotes' in update && update.checkZonaVincoloNotes !== this.checkZonaVincoloNotes) {
      this.checkZonaVincoloNotes = update.checkZonaVincoloNotes as string;
      this.$store.dispatch('updateTaskFields', { checkZonaVincoloNotes: this.checkZonaVincoloNotes });
    }
    // autodichiarazioneCliente
    if ('autodichiarazioneCliente' in update && update.autodichiarazioneCliente !== this.autodichiarazioneCliente) {
      this.autodichiarazioneCliente = update.autodichiarazioneCliente as BoxStatusType;
      this.$store.dispatch('updateTaskFields', { autodichiarazioneCliente: this.autodichiarazioneCliente });
    }
    // autodichiarazioneClienteNotes
    if ('autodichiarazioneClienteNotes' in update && update.autodichiarazioneClienteNotes !== this.autodichiarazioneClienteNotes) {
      this.autodichiarazioneClienteNotes = update.autodichiarazioneClienteNotes as string;
      this.$store.dispatch('updateTaskFields', { autodichiarazioneClienteNotes: this.autodichiarazioneClienteNotes });
    }
  }

  // Effetta la validazione del modulo
  async onValidate(status: 'completed' | 'error') {
    console.log(`${this.constructor.name}: onValidate(${status})`); // eslint-disable-line no-console

    // Sceglie se validare il modulo per un completamento o per un fallimento
    this.selectedStatus = status;

    // Avvia l'effettiva validazione
    const form = this.$refs.form as Vue & {
      validate: () => boolean;
      reset: () => boolean;
    };

    if (form) {
      const result = form.validate();
      console.log(`${this.constructor.name}: onValidate() form.validate() =`, result); // eslint-disable-line no-console
    } else {
      console.error(`${this.constructor.name}: onValidate() form =`, form); // eslint-disable-line no-console
      console.error(`${this.constructor.name}: onValidate() this.$refs =`, this.$refs); // eslint-disable-line no-console
    }

    return Promise.resolve();
  }

  async onEditAttachments() {
    console.log(`${this.constructor.name}: onEditAttachments()`); // eslint-disable-line no-console

    const currentTask = this.selectedTask;
    const expectedTask = this.selectedLead?.Tasks?.find((t) => t.name === 'V');

    // Seleziona solo se il Task non è già selezionato o è diverso
    if (!currentTask || currentTask.id !== expectedTask?.id) {
      await this.$store.dispatch('selectTask', {
        name: 'V',
        leadId: this.selectedLead?.id,
      });
    }

    this.editAttachmentsDialog = true;
  }

  onCloseEditAttachments() {
    console.log(`${this.constructor.name}: onCloseEditAttachments()`); // eslint-disable-line no-console

    // NON deselezionare il task se siamo in modalità readonly (task prop presente),
    // perché non siamo stati noi a selezionarlo.
    // In modalità readonly, il task viene passato via prop e non va toccato.
    if (this.task) {
      // Non fare nulla - siamo in modalità readonly
      return;
    }

    // Se non siamo in modalità readonly, potremmo aver selezionato il task
    // in onEditAttachments, ma non lo deselezioniamo qui perché
    // la lead deve rimanere selezionata nella vista Lead.vue
  }
}
